import React from "react";
import { Flex } from "antd";
import { useDispatch } from "react-redux";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import { setModalOpen } from "@/reducers/commonSlice";

const ApproveRejectGraceTime = ({
  isOpen,
  message = "",
  details = {},
  onSubmit = () => {},
  onReject = () => {},
}) => {
  const dispatch = useDispatch();
  const handleSubmit = () => {
    onSubmit(details);
  };
  const handleCancel = () => {
    onReject();
    dispatch(setModalOpen(false));
  };
  return (
    <ModalComponent isOpen={isOpen} width={347}>
      <Flex vertical gap="1rem" align="center">
        <div className="icon-wrapper">
          <img src="/assets/images/confirm.svg" alt="" />
        </div>
        <div className="body-b1 text-center">{message}</div>
        <Flex gap={"1rem"}>
          <ButtonComponent label="Approve" type="primary" onClick={handleSubmit} />
          <ButtonComponent label="Reject" type="default" onClick={handleCancel} />
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default ApproveRejectGraceTime;
